<template>
  <div class="c-modal__mask" @mousedown.self="$emit('close')">
    <div class="c-modal__wrapper">
      <div class="c-modal__container">
        <div class="c-modal__header o-grid o-grid--direction-row">
          <div class="o-grid__group">
            <div class="o-grid__item">
              <slot name="header"></slot>
            </div>
          </div>
        </div>
        <button
          class="c-modal__close o-button o-button--action o-button--round o-button--light"
          @click="$emit('close')"
          v-if="cornerClose"
        >
          <svg
            class="o-svg-icon o-button__icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use xlink:href="spritemap.svg#sprite-cross" x="0" y="0"></use>
          </svg>
        </button>
        <div class="c-modal__body">
          <slot name="body"> </slot>
        </div>

        <div class="c-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "c-modal",
  data() {
    return {};
  },
  props: {
    cornerClose: { type: Boolean, default: true }
  },
  mounted() {
    document.body.classList.add("u-overflow--hidden");
  },
  destroyed() {
    document.body.classList.remove("u-overflow--hidden");
  }
};
</script>
<style lang="scss">
.c-modal {
  &__mask {
    overflow: auto;
    position: fixed;
    z-index: z("modal");
    top: -5%;
    left: -5%;
    width: 110%;
    height: 110%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    flex: 0 0 auto;
    display: flex;
    padding: 100px 0 350px; // Assure there is always space for the DatePicker
  }

  &__container {
    width: 630px;
    max-width: 100%;
    margin: 0px auto;
    padding: 50px 0 0;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    position: relative;
  }

  &__header {
    padding: 0 50px;
    h3 {
      margin-top: 0;
    }
  }

  &__body {
    margin: 20px 0;
    padding: 0 50px;
  }
  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  &__footer {
    padding: 0 50px 70px;
  }
}
</style>
